module.exports = __webpack_public_path__ + "media/images/top/juel-8b34161aad133923ddb71c134d8f18d9.svg";